import React, { useState, useEffect, useCallback } from 'react';

const MESES_NOMES = ['Janeiro','Fevereiro','Março','Abril','Maio','Junho',
                     'Julho','Agosto','Setembro','Outubro','Novembro','Dezembro'];

const METODOS = [
  { value: 'pix',            label: 'PIX' },
  { value: 'dinheiro',       label: 'Dinheiro' },
  { value: 'cartao_credito', label: 'Cartão de Crédito' },
  { value: 'cartao_debito',  label: 'Cartão de Débito' },
  { value: 'transferencia',  label: 'Transferência' },
];

const PENDENCIA_LABELS = {
  auto_cobranca: {
    label: 'Cobrança não gerada',
    dica: 'O aluno agendou normalmente, mas a cobrança automática falhou. Crie a receita manualmente na aba Receitas e depois marque como resolvido aqui.',
  },
  fixo_sem_plano: {
    label: 'Fixo sem plano',
    dica: 'Aluno fixo sem plano compatível no catálogo. Cadastre um plano manualmente em Alunos & Planos e depois marque como resolvido aqui.',
  },
};

const CATEGORIAS_DESPESA = [
  { value: 'aluguel',     label: 'Aluguel' },
  { value: 'energia',     label: 'Energia' },
  { value: 'agua',        label: 'Água' },
  { value: 'internet',    label: 'Internet' },
  { value: 'equipamento', label: 'Equipamento' },
  { value: 'manutencao',  label: 'Manutenção' },
  { value: 'salario',     label: 'Salário' },
  { value: 'marketing',   label: 'Marketing' },
  { value: 'outro',       label: 'Outro' },
];

const fmt = (v) => Number(v || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const fmtDate = (d) => {
  if (!d) return '—';
  const s = typeof d === 'string' && d.includes('T') ? d.split('T')[0] : d;
  return new Date(s + 'T12:00:00').toLocaleDateString('pt-BR');
};

// ── Estilos base ────────────────────────────────────────────────────
const S = {
  container: { fontFamily: 'inherit', color: '#0f172a' },
  card: {
    background: '#fff', borderRadius: '12px', padding: '16px',
    border: '1px solid #e2e8f0', boxShadow: '0 1px 3px rgba(0,0,0,.06)',
    marginBottom: '16px'
  },
  grid4: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(130px,1fr))', gap: '10px', marginBottom: '16px' },
  statCard: (color) => ({
    background: '#fff', borderRadius: '12px', padding: '14px 16px',
    border: `1px solid ${color}30`, borderLeft: `4px solid ${color}`,
    boxShadow: '0 1px 3px rgba(0,0,0,.06)'
  }),
  statVal: { fontSize: '20px', fontWeight: 800, margin: '4px 0 2px' },
  statLabel: { fontSize: '11px', color: '#64748b', fontWeight: 500 },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: '13px' },
  th: { textAlign: 'left', padding: '9px 10px', background: '#f8fafc', borderBottom: '2px solid #e2e8f0', fontWeight: 600, color: '#475569', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '.03em', whiteSpace: 'nowrap' },
  td: { padding: '9px 10px', borderBottom: '1px solid #f1f5f9', verticalAlign: 'middle' },
  badge: (color, bg) => ({
    display: 'inline-block', padding: '2px 8px', borderRadius: '20px',
    fontSize: '11px', fontWeight: 600, color, background: bg, whiteSpace: 'nowrap'
  }),
  btn: (color='#0f5a30', ghost=false) => ({
    padding: '8px 14px', borderRadius: '8px', border: ghost ? `1px solid ${color}` : 'none',
    background: ghost ? 'transparent' : color, color: ghost ? color : '#fff',
    cursor: 'pointer', fontSize: '13px', fontWeight: 500, transition: 'opacity .15s',
    whiteSpace: 'nowrap', flexShrink: 0
  }),
  btnSm: (color='#0f5a30') => ({
    padding: '4px 10px', borderRadius: '6px', border: 'none',
    background: color + '15', color, cursor: 'pointer', fontSize: '12px', fontWeight: 500,
    whiteSpace: 'nowrap'
  }),
  input: {
    width: '100%', padding: '8px 12px', borderRadius: '8px',
    border: '1px solid #e2e8f0', fontSize: '16px', outline: 'none',
    boxSizing: 'border-box'
  },
  select: {
    width: '100%', padding: '8px 12px', borderRadius: '8px', border: '1px solid #e2e8f0',
    fontSize: '16px', background: '#fff', cursor: 'pointer', outline: 'none',
    boxSizing: 'border-box'
  },
  label: { display: 'block', fontSize: '13px', fontWeight: 500, color: '#475569', marginBottom: '4px' },
  formGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: '12px' },
  title: { fontSize: '16px', fontWeight: 700, marginBottom: '12px', color: '#1e293b' },
  alert: (type) => {
    const map = { success: ['#d1fae5','#059669'], error: ['#fee2e2','#dc2626'], info: ['#dbeafe','#2563eb'] };
    const [bg, color] = map[type] || map.info;
    return { background: bg, color, padding: '10px 14px', borderRadius: '8px', fontSize: '13px', marginBottom: '12px' };
  }
};

const statusBadge = (s) => {
  const map = {
    pago:      ['#065f46','#d1fae5'],
    pendente:  ['#92400e','#fef3c7'],
    atrasado:  ['#991b1b','#fee2e2'],
    cancelado: ['#374151','#f3f4f6'],
    ativo:     ['#1d4ed8','#dbeafe'],
    expirado:  ['#374151','#f3f4f6'],
  };
  const [c, bg] = map[s] || ['#374151','#f3f4f6'];
  const labels = { pago:'Pago', pendente:'Pendente', atrasado:'Atrasado', cancelado:'Cancelado', ativo:'Ativo', expirado:'Expirado' };
  return <span style={S.badge(c, bg)}>{labels[s] || s}</span>;
};

const tipoBadge = (t) => {
  const map = {
    mensalidade:  ['#1d4ed8','#dbeafe'],
    avulso:       ['#7c3aed','#ede9fe'],
    experimental: ['#0369a1','#e0f2fe'],
    pacote:       ['#065f46','#d1fae5'],
    parceria:     ['#92400e','#fef3c7'],
  };
  const labels = { mensalidade:'Mensalidade', avulso:'Avulso', experimental:'Experimental', pacote:'Pacote', parceria:'Parceria' };
  const [c, bg] = map[t] || ['#374151','#f3f4f6'];
  return <span style={S.badge(c, bg)}>{labels[t] || t}</span>;
};

const origemBadge = (o) => {
  const map = { Fixo:['#0369a1','#e0f2fe'], regular:['#0369a1','#e0f2fe'], wellhub:['#7c3aed','#ede9fe'], totalpass:['#065f46','#d1fae5'] };
  const labels = { Fixo:'⭐ Fixo', regular:'⭐ Fixo', wellhub:'Wellhub', totalpass:'Total Pass' };
  const [c, bg] = map[o] || ['#374151','#f3f4f6'];
  return <span style={S.badge(c, bg)}>{labels[o] || o}</span>;
};

// ── Barra de filtros responsiva ────────────────────────────────────
const FiltroBar = ({ isMobile, left, right }) => (
  <div style={{
    display: 'flex', flexDirection: isMobile ? 'column' : 'row',
    gap: '8px', marginBottom: '16px', alignItems: isMobile ? 'stretch' : 'center',
    flexWrap: 'wrap'
  }}>
    <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', flex: 1, alignItems: 'center' }}>
      {left}
    </div>
    {right && (
      <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', justifyContent: isMobile ? 'stretch' : 'flex-end' }}>
        {right}
      </div>
    )}
  </div>
);

// ── Campo ano compacto ─────────────────────────────────────────────
const AnoInput = ({ value, onChange }) => (
  <input type="number" value={value} onChange={e => onChange(parseInt(e.target.value))}
    style={{ ...S.select, width: '88px', flexShrink: 0 }} />
);

// ── Modal genérico ─────────────────────────────────────────────────
const Modal = ({ isOpen, onClose, title, children, width = '520px' }) => {
  if (!isOpen) return null;
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,.45)', display:'flex', alignItems:'flex-start', justifyContent:'center', zIndex:3000, padding:'1rem', overflowY:'auto', WebkitOverflowScrolling:'touch' }}>
      <div style={{ background:'#fff', borderRadius:'16px', width, maxWidth:'calc(100vw - 2rem)', boxShadow:'0 20px 50px rgba(0,0,0,.25)', margin:'auto', boxSizing:'border-box' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'16px 20px', borderBottom:'1px solid #f1f5f9' }}>
          <h3 style={{ margin:0, fontSize:'15px', fontWeight:700 }}>{title}</h3>
          <button onClick={onClose} style={{ background:'none', border:'none', cursor:'pointer', fontSize:'20px', color:'#94a3b8' }}>✕</button>
        </div>
        <div style={{ padding:'16px 20px' }}>{children}</div>
      </div>
    </div>
  );
};

// ── Wrapper tabela com scroll ──────────────────────────────────────
const TabelaScroll = ({ children }) => (
  <div style={{ overflowX:'auto', WebkitOverflowScrolling:'touch', borderRadius:'8px' }}>
    {children}
  </div>
);

// ── KPI Card ─────────────────────────────────────────────────────
const KpiCard = ({ label, value, sub, cor, variacao }) => (
  <div style={S.statCard(cor)}>
    <div style={S.statLabel}>{label}</div>
    <div style={{ ...S.statVal, color: cor }}>{value}</div>
    {sub && <div style={{ fontSize:'11px', color:'#94a3b8' }}>{sub}</div>}
    {variacao !== undefined && variacao !== null && (
      <div style={{ fontSize:'11px', color: parseFloat(variacao) >= 0 ? '#10b981' : '#ef4444', fontWeight:600, marginTop:'2px' }}>
        {parseFloat(variacao) >= 0 ? '▲' : '▼'} {Math.abs(variacao)}% vs. mês anterior
      </div>
    )}
  </div>
);

// ── Mini barra chart ──────────────────────────────────────────────
const BarChart = ({ data, max, cor = '#0f5a30', height = 48 }) => (
  <div style={{ display:'flex', alignItems:'flex-end', gap:'3px', height: `${height}px` }}>
    {data.map((v, i) => (
      <div key={i} style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', gap:'2px' }}>
        <div style={{
          width:'100%', background: i === data.length - 1 ? cor : cor + '60',
          height: `${max > 0 ? Math.max(4, Math.round((v / max) * height)) : 4}px`,
          borderRadius:'3px 3px 0 0', transition:'height .3s'
        }} />
      </div>
    ))}
  </div>
);

// ── Exportar CSV helper ────────────────────────────────────────────
const exportarCSV = (createApi) => async (tipo, params = {}) => {
  try {
    const api = createApi();
    const qs = new URLSearchParams({ tipo, ...params }).toString();
    const r = await api.get(`/admin/financeiro/exportar-csv?${qs}`, { responseType: 'blob' });
    const url = URL.createObjectURL(r.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = `financeiro_${tipo}_${new Date().toISOString().slice(0,10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  } catch { alert('Erro ao exportar'); }
};

// ================================================================
// DASHBOARD
// ================================================================
const Dashboard = ({ createApi, mes, ano, setMes, setAno, isMobile }) => {
  const [data, setData]       = useState(null);
  const [kpis, setKpis]       = useState(null);
  const [fluxo, setFluxo]     = useState(null);
  const [pendencias, setPendencias] = useState([]);
  const [loading, setLoading] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [msgLembrete, setMsgLembrete] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const api = createApi();
      const [r, rk, rf, rp] = await Promise.all([
        api.get(`/admin/financeiro/dashboard?mes=${mes}&ano=${ano}`),
        api.get(`/admin/financeiro/kpis?mes=${mes}&ano=${ano}`),
        api.get('/admin/financeiro/fluxo-caixa'),
        api.get('/admin/financeiro/pendencias-cobranca'),
      ]);
      setData(r.data);
      setKpis(rk.data);
      setFluxo(rf.data);
      setPendencias(rp.data.pendencias || []);
    } catch { /* silently fail */ }
    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mes, ano]);

  useEffect(() => { load(); }, [load]);

  const resolverPendencia = async (id) => {
    try {
      const api = createApi();
      await api.put(`/admin/financeiro/pendencias-cobranca/${id}`);
      setPendencias(prev => prev.filter(p => p.id !== id));
    } catch { /* silently fail */ }
  };

  const enviarLembretes = async () => {
    setEnviando(true);
    try {
      const api = createApi();
      const r = await api.post('/admin/financeiro/enviar-lembretes');
      setMsgLembrete(`✅ ${r.data.enviados} lembrete(s) enviado(s) de ${r.data.total_pendentes} pendente(s).`);
    } catch { setMsgLembrete('❌ Erro ao enviar lembretes'); }
    setEnviando(false);
    setTimeout(() => setMsgLembrete(null), 5000);
  };

  if (loading) return <div style={{ textAlign:'center', padding:'40px', color:'#94a3b8' }}>Carregando...</div>;
  if (!data) return null;

  // Dados do gráfico: últimos 6 meses do fluxo
  const fluxoMeses = fluxo?.meses || [];
  const receitasPorMes = fluxoMeses.map(m => {
    const rows = fluxo.receitas.filter(r => r.mes_referencia?.slice(0,7) === m.slice(0,7));
    return rows.reduce((s, r) => s + parseFloat(r.recebido || 0), 0);
  });
  const maxFluxo = Math.max(...receitasPorMes, 1);

  return (
    <div>
      <FiltroBar
        isMobile={isMobile}
        left={<>
          <span style={{ fontWeight:600, color:'#475569', whiteSpace:'nowrap' }}>Referência:</span>
          <select style={{ ...S.select, flex:1, minWidth:'120px', maxWidth:'180px' }} value={mes} onChange={e => setMes(parseInt(e.target.value))}>
            {MESES_NOMES.map((n,i) => <option key={i+1} value={i+1}>{n}</option>)}
          </select>
          <AnoInput value={ano} onChange={setAno} />
          <button style={S.btn()} onClick={load}>Atualizar</button>
        </>}
        right={<>
          <button style={S.btn('#f59e0b')} onClick={enviarLembretes} disabled={enviando}>
            {enviando ? 'Enviando...' : '📧 Enviar Lembretes'}
          </button>
        </>}
      />

      {msgLembrete && <div style={S.alert(msgLembrete.startsWith('✅') ? 'success' : 'error')}>{msgLembrete}</div>}

      {/* Pendências financeiras automáticas */}
      {pendencias.length > 0 && (
        <div style={{ ...S.card, borderLeft: '4px solid #ef4444' }}>
          <div style={S.title}>⚠️ {pendencias.length} pendência(s) financeira(s)</div>
          <div style={{ fontSize:'12px', color:'#64748b', marginBottom:'10px' }}>
            {PENDENCIA_LABELS[pendencias[0]?.tipo]?.dica || 'Resolva manualmente e marque como resolvido.'}
          </div>
          <TabelaScroll>
            <table style={S.table}>
              <thead><tr>{['Aluno','Tipo','Detalhe','Data',''].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
              <tbody>
                {pendencias.map(p => (
                  <tr key={p.id}>
                    <td style={S.td}>{p.aluno_nome || `Aluno #${p.aluno_id}`}</td>
                    <td style={S.td}>{PENDENCIA_LABELS[p.tipo]?.label || p.tipo}</td>
                    <td style={S.td}>{p.erro}</td>
                    <td style={S.td}>{fmtDate(p.created_at?.split('T')[0])}</td>
                    <td style={S.td}>
                      <button style={S.btnSm()} onClick={() => resolverPendencia(p.id)}>Marcar resolvido</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </TabelaScroll>
        </div>
      )}

      {/* KPIs principais */}
      <div style={S.grid4}>
        <KpiCard label="Receita Recebida" value={fmt(data.receita.total)} sub={`${data.receita.qtd} pagamento(s)`} cor="#10b981" variacao={kpis?.variacao_receita} />
        <KpiCard label="Despesas" value={fmt(data.despesas.total)} sub={`${data.despesas.qtd} lançamento(s)`} cor="#ef4444" />
        <KpiCard label="Lucro Líquido" value={fmt(data.lucro)} cor={data.lucro >= 0 ? '#0f5a30' : '#f59e0b'} />
        <KpiCard label="Ticket Médio" value={fmt(kpis?.ticket_medio || 0)} sub={`${data.alunos_ativos} plano(s) ativo(s)`} cor="#0ea5e9" />
      </div>

      <div style={{ display:'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr', gap:'12px', marginBottom:'16px' }}>
        {/* Taxa de inadimplência */}
        <div style={S.statCard('#f59e0b')}>
          <div style={S.statLabel}>Inadimplência</div>
          <div style={{ display:'flex', alignItems:'baseline', gap:'8px' }}>
            <div style={{ ...S.statVal, color: parseFloat(kpis?.taxa_inadimplencia) > 20 ? '#ef4444' : '#f59e0b' }}>
              {kpis?.taxa_inadimplencia || 0}%
            </div>
            <div style={{ fontSize:'13px', color:'#94a3b8' }}>{data.inadimplentes} inadimplente(s)</div>
          </div>
          <div style={{ marginTop:'8px', height:'6px', borderRadius:'3px', background:'#e2e8f0', overflow:'hidden' }}>
            <div style={{ width:`${Math.min(100, kpis?.taxa_inadimplencia || 0)}%`, height:'100%', background: parseFloat(kpis?.taxa_inadimplencia) > 20 ? '#ef4444' : '#f59e0b', transition:'width .5s' }} />
          </div>
        </div>

        {/* Projeção */}
        {fluxo?.projecao_mensal && (
          <div style={S.statCard('#0f5a30')}>
            <div style={S.statLabel}>Receita Projetada (planos ativos)</div>
            <div style={{ ...S.statVal, color:'#0f5a30' }}>{fmt(fluxo.projecao_mensal.receita)}</div>
            <div style={{ fontSize:'11px', color:'#94a3b8' }}>{fluxo.projecao_mensal.alunos} aluno(s) com plano mensal ativo</div>
          </div>
        )}
      </div>

      {/* Gráfico de evolução */}
      {receitasPorMes.some(v => v > 0) && (
        <div style={S.card}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'12px' }}>
            <div style={S.title}>Evolução de Receita (6 meses)</div>
          </div>
          <BarChart data={receitasPorMes} max={maxFluxo} cor="#10b981" height={60} />
          <div style={{ display:'flex', gap:'3px', marginTop:'4px' }}>
            {fluxoMeses.map((m, i) => (
              <div key={i} style={{ flex:1, textAlign:'center', fontSize:'10px', color:'#94a3b8' }}>
                {m.slice(5,7)}/{m.slice(2,4)}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Breakdown receita por tipo */}
      {data.receita_por_tipo?.length > 0 && (
        <div style={S.card}>
          <div style={S.title}>Receita por Tipo — {MESES_NOMES[mes-1]}</div>
          <div style={{ display:'flex', gap:'8px', flexWrap:'wrap' }}>
            {data.receita_por_tipo.map(r => (
              <div key={r.tipo_receita} style={{ ...S.statCard('#0f5a30'), flex:'1 1 120px', minWidth:'120px' }}>
                <div style={{ marginBottom:'4px' }}>{tipoBadge(r.tipo_receita)}</div>
                <div style={{ fontSize:'16px', fontWeight:700, color:'#1e293b' }}>{fmt(r.total)}</div>
                <div style={{ fontSize:'11px', color:'#94a3b8' }}>{r.qtd} lançamento(s)</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Alunos por origem */}
      {data.alunos_por_origem?.length > 0 && (
        <div style={S.card}>
          <div style={S.title}>Alunos por Origem</div>
          <div style={{ display:'flex', gap:'8px', flexWrap:'wrap' }}>
            {data.alunos_por_origem.map(o => (
              <div key={o.origem} style={{ ...S.statCard('#f59e0b'), flex:'1 1 100px', minWidth:'100px' }}>
                <div style={{ marginBottom:'4px' }}>{origemBadge(o.origem)}</div>
                <div style={{ fontSize:'20px', fontWeight:700, color:'#1e293b' }}>{o.qtd}</div>
                <div style={{ fontSize:'11px', color:'#94a3b8' }}>aluno(s)</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Pendentes */}
      {data.proximos_vencimentos.length > 0 && (
        <div style={S.card}>
          <div style={S.title}>Pendentes / Atrasados — {MESES_NOMES[mes-1]}</div>
          <TabelaScroll>
            <table style={S.table}>
              <thead><tr>{['Aluno','Valor','Vencimento','Origem','Status'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
              <tbody>
                {data.proximos_vencimentos.map(m => (
                  <tr key={m.id}>
                    <td style={S.td}>{m.aluno_nome}</td>
                    <td style={S.td}>{fmt(m.valor)}</td>
                    <td style={S.td}>{fmtDate(m.data_vencimento)}</td>
                    <td style={S.td}>{origemBadge(m.aluno_origem || 'regular')}</td>
                    <td style={S.td}>{statusBadge(m.status)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </TabelaScroll>
        </div>
      )}
    </div>
  );
};

// ================================================================
// MENSALIDADES
// ================================================================
const Mensalidades = ({ createApi, mes, ano, setMes, setAno, isMobile }) => {
  const [lista, setLista] = useState([]);
  const [alunos, setAlunos] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [alunoPlanos, setAlunoPlanos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [filtroStatus, setFiltroStatus] = useState('');
  const [modalPagar, setModalPagar] = useState(null);
  const [modalEditar, setModalEditar] = useState(null);
  const [modalNova, setModalNova] = useState(false);
  const [modalGerar, setModalGerar] = useState(false);
  const [formPagar, setFormPagar] = useState({ metodo_pagamento:'pix', data_pagamento:'' });
  const [formEditar, setFormEditar] = useState({});
  const [formNova, setFormNova] = useState({ aluno_id:'', aluno_plano_id:'', produto_id:'', mes_referencia:'', valor_unitario:'', valor:'', quantidade:'1', descricao:'', data_vencimento:'', observacao:'', tipo_receita:'produto' });
  const [gerarForm, setGerarForm] = useState({ dia_vencimento:10 });

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const api = createApi();
      const params = new URLSearchParams({ mes, ano });
      if (filtroStatus) params.set('status', filtroStatus);
      const [r, ra, rp] = await Promise.all([
        api.get(`/admin/financeiro/mensalidades?${params}`),
        api.get('/admin/usuarios'),
        api.get('/admin/financeiro/produtos?ativo=true'),
      ]);
      setLista(r.data.mensalidades || []);
      setAlunos(ra.data || []);
      setProdutos(rp.data.produtos || []);
    } catch { /* silently fail */ }
    setLoading(false);
  }, [mes, ano, filtroStatus, createApi]);

  useEffect(() => { load(); }, [load]);

  const carregarAlunoPlanos = async (alunoId) => {
    if (!alunoId) return;
    const api = createApi();
    const r = await api.get(`/admin/financeiro/aluno-planos?aluno_id=${alunoId}`);
    setAlunoPlanos(r.data.aluno_planos || []);
  };

  const registrarPagamento = async () => {
    try {
      const api = createApi();
      await api.put(`/admin/financeiro/mensalidades/${modalPagar.id}`, {
        status: 'pago',
        data_pagamento: formPagar.data_pagamento || new Date().toISOString().split('T')[0],
        metodo_pagamento: formPagar.metodo_pagamento
      });
      setMsg({ type:'success', text:'Pagamento registrado!' });
      setModalPagar(null);
      load();
    } catch (e) { setMsg({ type:'error', text: e.response?.data?.error || 'Erro' }); }
  };

  const criarMensalidade = async () => {
    try {
      const api = createApi();
      await api.post('/admin/financeiro/mensalidades', {
        ...formNova,
        produto_id: formNova.produto_id && formNova.produto_id !== '__manual__' ? formNova.produto_id : null,
        mes_referencia: formNova.mes_referencia || `${ano}-${String(mes).padStart(2,'0')}-01`,
      });
      setMsg({ type:'success', text:'Receita criada!' });
      setModalNova(false);
      setFormNova({ aluno_id:'', aluno_plano_id:'', produto_id:'', mes_referencia:'', valor_unitario:'', valor:'', quantidade:'1', descricao:'', data_vencimento:'', observacao:'', tipo_receita:'produto' });
      await load();
    } catch (e) { setMsg({ type:'error', text: e.response?.data?.error || 'Erro' }); }
  };

  const gerarMensalidades = async () => {
    try {
      const api = createApi();
      const r = await api.post('/admin/financeiro/mensalidades/gerar', { mes, ano, ...gerarForm });
      setMsg({ type:'success', text:`${r.data.criadas} mensalidade(s) gerada(s). ${r.data.existentes} já existiam.` });
      setModalGerar(false);
      load();
    } catch (e) { setMsg({ type:'error', text: e.response?.data?.error || 'Erro' }); }
  };

  const excluir = async (id) => {
    if (!window.confirm('Excluir esta receita?')) return;
    const api = createApi();
    await api.delete(`/admin/financeiro/mensalidades/${id}`);
    load();
  };

  const abrirEditar = (m) => {
    setFormEditar({
      valor: m.valor,
      descricao: m.descricao || m.produto_nome || '',
      observacao: m.observacao || '',
      data_vencimento: m.data_vencimento?.split('T')[0] || '',
      status: m.status,
      metodo_pagamento: m.metodo_pagamento || '',
      data_pagamento: m.data_pagamento?.split('T')[0] || '',
      tipo_receita: m.tipo_receita || 'produto',
    });
    setModalEditar(m);
  };

  const salvarEdicao = async () => {
    try {
      const api = createApi();
      await api.put(`/admin/financeiro/mensalidades/${modalEditar.id}`, formEditar);
      setMsg({ type:'success', text:'Receita atualizada!' });
      setModalEditar(null);
      await load();
    } catch (e) { setMsg({ type:'error', text: e.response?.data?.error || 'Erro' }); }
  };

  return (
    <div>
      {msg && <div style={S.alert(msg.type)}>{msg.text}</div>}

      <FiltroBar
        isMobile={isMobile}
        left={<>
          <select style={{ ...S.select, flex:1, minWidth:'110px', maxWidth:'170px' }} value={mes} onChange={e => setMes(parseInt(e.target.value))}>
            {MESES_NOMES.map((n,i) => <option key={i+1} value={i+1}>{n}</option>)}
          </select>
          <AnoInput value={ano} onChange={setAno} />
          <select style={{ ...S.select, flex:1, minWidth:'110px', maxWidth:'160px' }} value={filtroStatus} onChange={e => setFiltroStatus(e.target.value)}>
            <option value="">Todos</option>
            <option value="pendente">Pendente</option>
            <option value="pago">Pago</option>
            <option value="atrasado">Atrasado</option>
            <option value="cancelado">Cancelado</option>
          </select>
          {lista.length > 0 && (
            <span style={{ fontWeight:700, color:'#10b981', whiteSpace:'nowrap', fontSize:'14px' }}>
              Total: {fmt(lista.reduce((s, m) => s + parseFloat(m.valor || 0), 0))}
            </span>
          )}
        </>}
        right={<>
          <button style={{ ...S.btn('#10b981'), flex: isMobile ? 1 : 'none' }} onClick={() => setModalGerar(true)}>⚡ Gerar lote</button>
          <button style={{ ...S.btn('#64748b', true), flex: isMobile ? 1 : 'none' }} onClick={() => exportarCSV(createApi)('receitas', { mes, ano })}>⬇ CSV</button>
          <button style={{ ...S.btn(), flex: isMobile ? 1 : 'none' }} onClick={() => setModalNova(true)}>+ Nova</button>
        </>}
      />

      {loading ? <div style={{ textAlign:'center', padding:'30px', color:'#94a3b8' }}>Carregando...</div> : (
        <TabelaScroll>
          <table style={S.table}>
            <thead>
              <tr>{['Aluno','Produto/Serviço','Tipo','Valor','Vencimento','Pagamento','Status','Ações'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {lista.length === 0 && <tr><td colSpan={8} style={{ ...S.td, textAlign:'center', color:'#94a3b8', padding:'30px' }}>Nenhuma mensalidade encontrada</td></tr>}
              {lista.map(m => (
                <tr key={m.id}>
                  <td style={S.td}><div style={{ fontWeight:600 }}>{m.aluno_nome || <span style={{ color:'#94a3b8' }}>Sem aluno</span>}</div><div style={{ fontSize:'11px', color:'#94a3b8' }}>{m.aluno_email}</div></td>
                  <td style={S.td}><div style={{ fontWeight:500 }}>{m.produto_nome || m.descricao || m.plano_nome || '—'}</div>{parseFloat(m.quantidade) > 1 && <div style={{ fontSize:'11px', color:'#94a3b8' }}>{parseFloat(m.quantidade) % 1 === 0 ? parseInt(m.quantidade) : parseFloat(m.quantidade)}x</div>}</td>
                  <td style={S.td}>{tipoBadge(m.tipo_receita || 'mensalidade')}</td>
                  <td style={{ ...S.td, fontWeight:700 }}>{fmt(m.valor)}</td>
                  <td style={S.td}>{fmtDate(m.data_vencimento)}</td>
                  <td style={S.td}>{fmtDate(m.data_pagamento)}</td>
                  <td style={S.td}>{statusBadge(m.status)}</td>
                  <td style={S.td}>
                    <div style={{ display:'flex', gap:'4px', flexWrap:'wrap' }}>
                      {m.status !== 'pago' && <button style={S.btnSm('#10b981')} onClick={() => { setModalPagar(m); setFormPagar({ metodo_pagamento:'pix', data_pagamento: new Date().toISOString().split('T')[0] }); }}>$ Pagar</button>}
                      <button style={S.btnSm('#0f5a30')} onClick={() => abrirEditar(m)}>✏️</button>
                      <button style={S.btnSm('#ef4444')} onClick={() => excluir(m.id)}>🗑</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </TabelaScroll>
      )}

      <Modal isOpen={!!modalPagar} onClose={() => setModalPagar(null)} title="Registrar Pagamento">
        {modalPagar && (
          <div>
            <p style={{ marginTop:0 }}><strong>{modalPagar.aluno_nome}</strong> — {fmt(modalPagar.valor)} — {MESES_NOMES[mes-1]}/{ano}</p>
            <div style={S.formGrid}>
              <div>
                <label style={S.label}>Método</label>
                <select style={S.select} value={formPagar.metodo_pagamento} onChange={e => setFormPagar(p => ({ ...p, metodo_pagamento: e.target.value }))}>
                  {METODOS.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
                </select>
              </div>
              <div>
                <label style={S.label}>Data do Pagamento</label>
                <input type="date" style={S.input} value={formPagar.data_pagamento} onChange={e => setFormPagar(p => ({ ...p, data_pagamento: e.target.value }))} />
              </div>
            </div>
            <div style={{ display:'flex', gap:'8px', marginTop:'16px', justifyContent:'flex-end' }}>
              <button style={S.btn('#64748b', true)} onClick={() => setModalPagar(null)}>Cancelar</button>
              <button style={S.btn('#10b981')} onClick={registrarPagamento}>Confirmar</button>
            </div>
          </div>
        )}
      </Modal>

      <Modal isOpen={!!modalEditar} onClose={() => setModalEditar(null)} title="Editar Receita" width="480px">
        <div style={S.formGrid}>
          <div style={{ gridColumn:'1/-1' }}>
            <label style={S.label}>Descrição / Produto</label>
            <input style={S.input} value={formEditar.descricao || ''} onChange={e => setFormEditar(f => ({ ...f, descricao: e.target.value }))} />
          </div>
          <div>
            <label style={S.label}>Valor (R$)</label>
            <input type="number" step="0.01" style={S.input} value={formEditar.valor || ''} onChange={e => setFormEditar(f => ({ ...f, valor: e.target.value }))} />
          </div>
          <div>
            <label style={S.label}>Tipo</label>
            <select style={S.select} value={formEditar.tipo_receita || 'produto'} onChange={e => setFormEditar(f => ({ ...f, tipo_receita: e.target.value }))}>
              <option value="produto">Produto/Serviço</option>
              <option value="mensalidade">Mensalidade</option>
              <option value="avulso">Avulso</option>
              <option value="experimental">Experimental</option>
              <option value="pacote">Pacote</option>
              <option value="parceria">Parceria</option>
            </select>
          </div>
          <div>
            <label style={S.label}>Status</label>
            <select style={S.select} value={formEditar.status || 'pendente'} onChange={e => setFormEditar(f => ({ ...f, status: e.target.value }))}>
              <option value="pendente">Pendente</option>
              <option value="pago">Pago</option>
              <option value="atrasado">Atrasado</option>
              <option value="cancelado">Cancelado</option>
            </select>
          </div>
          <div>
            <label style={S.label}>Vencimento</label>
            <input type="date" style={S.input} value={formEditar.data_vencimento || ''} onChange={e => setFormEditar(f => ({ ...f, data_vencimento: e.target.value }))} />
          </div>
          <div>
            <label style={S.label}>Data Pagamento</label>
            <input type="date" style={S.input} value={formEditar.data_pagamento || ''} onChange={e => setFormEditar(f => ({ ...f, data_pagamento: e.target.value }))} />
          </div>
          {formEditar.status === 'pago' && (
            <div style={{ gridColumn:'1/-1' }}>
              <label style={S.label}>Método de Pagamento</label>
              <select style={S.select} value={formEditar.metodo_pagamento || 'pix'} onChange={e => setFormEditar(f => ({ ...f, metodo_pagamento: e.target.value }))}>
                {METODOS.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
              </select>
            </div>
          )}
          <div style={{ gridColumn:'1/-1' }}>
            <label style={S.label}>Observação</label>
            <input style={S.input} value={formEditar.observacao || ''} onChange={e => setFormEditar(f => ({ ...f, observacao: e.target.value }))} />
          </div>
        </div>
        <div style={{ display:'flex', gap:'8px', marginTop:'16px', justifyContent:'flex-end' }}>
          <button style={S.btn('#64748b', true)} onClick={() => setModalEditar(null)}>Cancelar</button>
          <button style={S.btn()} onClick={salvarEdicao}>Salvar</button>
        </div>
      </Modal>

      <Modal isOpen={modalNova} onClose={() => setModalNova(false)} title="Nova Receita" width="560px">
        <div style={S.formGrid}>
          {/* Produto — campo principal */}
          <div style={{ gridColumn:'1/-1' }}>
            <label style={S.label}>Produto / Serviço *</label>
            <select style={S.select} value={formNova.produto_id} onChange={e => {
              const p = produtos.find(x => x.id === parseInt(e.target.value));
              const q = parseFloat(formNova.quantidade) || 1;
              const vu = p ? parseFloat(p.valor) : 0;
              setFormNova(f => ({
                ...f, produto_id: e.target.value,
                valor_unitario: p ? String(vu) : '',
                valor: p ? (vu * q).toFixed(2) : '',
                descricao: e.target.value === '__manual__' ? '' : (p ? p.nome : f.descricao),
                tipo_receita: p ? (p.categoria === 'plano' ? 'mensalidade' : p.categoria === 'pacote' ? 'pacote' : p.categoria === 'aula' ? 'avulso' : 'produto') : 'produto',
              }));
            }}>
              <option value="">Selecione um produto...</option>
              <option value="__manual__">✏️ Preencher manualmente...</option>
              {produtos.map(p => <option key={p.id} value={p.id}>{p.nome} — {fmt(p.valor)}</option>)}
            </select>
          </div>

          {/* Campo livre quando manual */}
          <div style={{ gridColumn:'1/-1' }}>
            <label style={S.label}>
              {formNova.produto_id === '__manual__' ? 'Nome do Produto/Serviço *' : 'Descrição / Detalhes'}
            </label>
            <input
              style={S.input}
              value={formNova.descricao}
              onChange={e => setFormNova(f => ({ ...f, descricao: e.target.value }))}
              placeholder={formNova.produto_id === '__manual__' ? 'Ex: Consultoria nutricional, Venda de acessório...' : 'Detalhe desta venda específica'}
            />
          </div>

          {/* Aluno — opcional */}
          <div style={{ gridColumn:'1/-1' }}>
            <label style={S.label}>Aluno <span style={{ color:'#94a3b8', fontWeight:400 }}>(opcional)</span></label>
            <select style={S.select} value={formNova.aluno_id} onChange={e => { setFormNova(f => ({ ...f, aluno_id: e.target.value, aluno_plano_id:'' })); carregarAlunoPlanos(e.target.value); }}>
              <option value="">Sem aluno (venda genérica)</option>
              {alunos.map(a => <option key={a.id} value={a.id}>{a.nome}</option>)}
            </select>
          </div>

          <div>
            <label style={S.label}>Preço Unitário (R$)</label>
            <input type="number" step="0.01" min="0" style={S.input}
              value={formNova.valor_unitario}
              onChange={e => {
                const vu = parseFloat(e.target.value) || 0;
                const q = parseFloat(formNova.quantidade) || 1;
                setFormNova(f => ({ ...f, valor_unitario: e.target.value, valor: (vu * q).toFixed(2) }));
              }}
              placeholder="0,00"
            />
          </div>

          <div>
            <label style={S.label}>Quantidade</label>
            <input type="number" step="0.5" min="0.5" style={S.input}
              value={formNova.quantidade}
              onChange={e => {
                const q = parseFloat(e.target.value) || 1;
                const vu = parseFloat(formNova.valor_unitario) || 0;
                setFormNova(f => ({ ...f, quantidade: e.target.value, valor: (vu * q).toFixed(2) }));
              }}
            />
          </div>

          <div>
            <label style={S.label}>Valor Total (R$)</label>
            <input type="number" step="0.01" style={{ ...S.input, background:'#f8fafc', fontWeight:700, color:'#10b981' }}
              value={formNova.valor}
              onChange={e => setFormNova(f => ({ ...f, valor: e.target.value }))}
              placeholder="0,00"
            />
            {formNova.valor_unitario && formNova.quantidade > 1 && (
              <div style={{ fontSize:'11px', color:'#94a3b8', marginTop:'3px' }}>
                {fmt(formNova.valor_unitario)} × {formNova.quantidade} = {fmt(formNova.valor)}
              </div>
            )}
          </div>

          <div>
            <label style={S.label}>Tipo de Receita</label>
            <select style={S.select} value={formNova.tipo_receita} onChange={e => setFormNova(f => ({ ...f, tipo_receita: e.target.value }))}>
              <option value="produto">Produto/Serviço</option>
              <option value="mensalidade">Mensalidade</option>
              <option value="avulso">Avulso</option>
              <option value="experimental">Experimental</option>
              <option value="pacote">Pacote</option>
              <option value="parceria">Parceria (Wellhub/TP)</option>
            </select>
          </div>

          <div>
            <label style={S.label}>Mês de Referência</label>
            <input type="month" style={S.input} value={formNova.mes_referencia ? formNova.mes_referencia.slice(0,7) : `${ano}-${String(mes).padStart(2,'0')}`} onChange={e => setFormNova(f => ({ ...f, mes_referencia: e.target.value + '-01' }))} />
          </div>

          <div>
            <label style={S.label}>Vencimento</label>
            <input type="date" style={S.input} value={formNova.data_vencimento} onChange={e => setFormNova(f => ({ ...f, data_vencimento: e.target.value }))} />
          </div>

          <div style={{ gridColumn:'1/-1' }}>
            <label style={S.label}>Observação interna</label>
            <input style={S.input} value={formNova.observacao} onChange={e => setFormNova(f => ({ ...f, observacao: e.target.value }))} />
          </div>
        </div>
        <div style={{ display:'flex', gap:'8px', marginTop:'16px', justifyContent:'flex-end' }}>
          <button style={S.btn('#64748b', true)} onClick={() => setModalNova(false)}>Cancelar</button>
          <button style={S.btn()} onClick={criarMensalidade} disabled={!formNova.produto_id && !formNova.valor}>Criar Receita</button>
        </div>
      </Modal>

      <Modal isOpen={modalGerar} onClose={() => setModalGerar(false)} title={`Gerar — ${MESES_NOMES[mes-1]}/${ano}`}>
        <p style={{ marginTop:0, color:'#475569', fontSize:'13px' }}>Gera mensalidades para todos os alunos com plano ativo. Alunos que já têm cobrança no mês serão ignorados.</p>
        <div>
          <label style={S.label}>Dia de Vencimento</label>
          <input type="number" min="1" max="31" style={{ ...S.input, maxWidth:'120px' }} value={gerarForm.dia_vencimento} onChange={e => setGerarForm(f => ({ ...f, dia_vencimento: e.target.value }))} />
        </div>
        <div style={{ display:'flex', gap:'8px', marginTop:'16px', justifyContent:'flex-end' }}>
          <button style={S.btn('#64748b', true)} onClick={() => setModalGerar(false)}>Cancelar</button>
          <button style={S.btn('#10b981')} onClick={gerarMensalidades}>Gerar</button>
        </div>
      </Modal>
    </div>
  );
};

// ================================================================
// ALUNOS & PLANOS
// ================================================================
const AlunosPlanos = ({ createApi, isMobile }) => {
  const [lista, setLista] = useState([]);
  const [planos, setPlanos] = useState([]);
  const [alunos, setAlunos] = useState([]);
  const [msg, setMsg] = useState(null);
  const [modalVincular, setModalVincular] = useState(false);
  const [modalEditar, setModalEditar] = useState(null);
  const emptyForm = { aluno_id:'', plano_id:'', data_inicio: new Date().toISOString().split('T')[0], observacao:'' };
  const [form, setForm] = useState(emptyForm);
  const [formEditar, setFormEditar] = useState({});

  const load = useCallback(async () => {
    const api = createApi();
    const [r, rp, ra] = await Promise.all([
      api.get('/admin/financeiro/aluno-planos'),
      api.get('/admin/financeiro/planos'),
      api.get('/admin/usuarios'),
    ]);
    setLista(r.data.aluno_planos || []);
    setPlanos(rp.data.planos || []);
    setAlunos(ra.data || []);
  }, [createApi]);

  useEffect(() => { load(); }, [load]);

  const vincular = async () => {
    try {
      const api = createApi();
      await api.post('/admin/financeiro/aluno-planos', form);
      setMsg({ type:'success', text:'Plano vinculado!' });
      setModalVincular(false);
      setForm(emptyForm);
      load();
    } catch (e) { setMsg({ type:'error', text: e.response?.data?.error || 'Erro' }); }
  };

  const salvarEdicao = async () => {
    try {
      const api = createApi();
      await api.put(`/admin/financeiro/aluno-planos/${modalEditar.id}`, formEditar);
      setMsg({ type:'success', text:'Plano atualizado!' });
      setModalEditar(null);
      load();
    } catch (e) { setMsg({ type:'error', text: e.response?.data?.error || 'Erro' }); }
  };

  const excluir = async (id) => {
    if (!window.confirm('Excluir este vínculo de plano?')) return;
    try {
      const api = createApi();
      await api.delete(`/admin/financeiro/aluno-planos/${id}`);
      load();
    } catch (e) { setMsg({ type:'error', text: e.response?.data?.error || 'Erro ao excluir' }); }
  };

  const abrirEditar = (ap) => {
    setFormEditar({
      status: ap.status,
      data_fim: ap.data_fim?.split('T')[0] || '',
      observacao: ap.observacao || '',
      aulas_usadas: ap.aulas_usadas || 0,
    });
    setModalEditar(ap);
  };

  return (
    <div>
      {msg && <div style={S.alert(msg.type)}>{msg.text}</div>}
      <div style={{ display:'flex', justifyContent:'flex-end', marginBottom:'12px' }}>
        <button style={S.btn()} onClick={() => { setForm(emptyForm); setModalVincular(true); }}>+ Vincular Plano</button>
      </div>
      <TabelaScroll>
        <table style={S.table}>
          <thead><tr>{['Aluno','Plano','Tipo','Valor','Início','Status','Ações'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
          <tbody>
            {lista.length === 0 && <tr><td colSpan={7} style={{ ...S.td, textAlign:'center', color:'#94a3b8', padding:'30px' }}>Nenhum vínculo encontrado</td></tr>}
            {lista.map(ap => (
              <tr key={ap.id}>
                <td style={S.td}><div style={{ fontWeight:600 }}>{ap.aluno_nome}</div><div style={{ fontSize:'11px', color:'#94a3b8' }}>{ap.aluno_email}</div></td>
                <td style={S.td}>
                  <div>{ap.plano_nome}</div>
                  {ap.plano_tipo === 'pacote' && ap.plano_num_aulas && (
                    <div style={{ fontSize:'11px', color:'#94a3b8' }}>{ap.aulas_usadas || 0}/{ap.plano_num_aulas} aulas</div>
                  )}
                </td>
                <td style={S.td}>{tipoBadge(ap.plano_tipo)}</td>
                <td style={{ ...S.td, fontWeight:700 }}>{fmt(ap.plano_valor)}</td>
                <td style={S.td}>{fmtDate(ap.data_inicio)}</td>
                <td style={S.td}>{statusBadge(ap.status)}</td>
                <td style={S.td}>
                  <div style={{ display:'flex', gap:'4px' }}>
                    <button style={S.btnSm('#0f5a30')} onClick={() => abrirEditar(ap)}>✏️</button>
                    <button style={S.btnSm('#ef4444')} onClick={() => excluir(ap.id)}>🗑</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </TabelaScroll>

      {/* Modal Vincular */}
      <Modal isOpen={modalVincular} onClose={() => setModalVincular(false)} title="Vincular Plano ao Aluno">
        <div style={S.formGrid}>
          <div style={{ gridColumn:'1/-1' }}>
            <label style={S.label}>Aluno</label>
            <select style={S.select} value={form.aluno_id} onChange={e => setForm(f => ({ ...f, aluno_id: e.target.value }))}>
              <option value="">Selecione...</option>
              {alunos.map(a => <option key={a.id} value={a.id}>{a.nome}</option>)}
            </select>
          </div>
          <div style={{ gridColumn:'1/-1' }}>
            <label style={S.label}>Plano</label>
            <select style={S.select} value={form.plano_id} onChange={e => setForm(f => ({ ...f, plano_id: e.target.value }))}>
              <option value="">Selecione...</option>
              {planos.filter(p => p.ativo).map(p => <option key={p.id} value={p.id}>{p.nome} — {fmt(p.valor)}</option>)}
            </select>
          </div>
          <div>
            <label style={S.label}>Data de Início</label>
            <input type="date" style={S.input} value={form.data_inicio} onChange={e => setForm(f => ({ ...f, data_inicio: e.target.value }))} />
          </div>
          <div>
            <label style={S.label}>Observação</label>
            <input style={S.input} value={form.observacao} onChange={e => setForm(f => ({ ...f, observacao: e.target.value }))} />
          </div>
        </div>
        <div style={{ display:'flex', gap:'8px', marginTop:'16px', justifyContent:'flex-end' }}>
          <button style={S.btn('#64748b', true)} onClick={() => setModalVincular(false)}>Cancelar</button>
          <button style={S.btn()} onClick={vincular} disabled={!form.aluno_id || !form.plano_id}>Vincular</button>
        </div>
      </Modal>

      {/* Modal Editar */}
      <Modal isOpen={!!modalEditar} onClose={() => setModalEditar(null)} title="Editar Vínculo de Plano">
        {modalEditar && (
          <div style={S.formGrid}>
            <div style={{ gridColumn:'1/-1', background:'#f8fafc', borderRadius:'8px', padding:'10px 12px', fontSize:'13px' }}>
              <strong>{modalEditar.aluno_nome}</strong> — {modalEditar.plano_nome} ({fmt(modalEditar.plano_valor)})
            </div>
            <div>
              <label style={S.label}>Status</label>
              <select style={S.select} value={formEditar.status || 'ativo'} onChange={e => setFormEditar(f => ({ ...f, status: e.target.value }))}>
                <option value="ativo">Ativo</option>
                <option value="cancelado">Cancelado</option>
                <option value="expirado">Expirado</option>
              </select>
            </div>
            <div>
              <label style={S.label}>Data de Encerramento</label>
              <input type="date" style={S.input} value={formEditar.data_fim || ''} onChange={e => setFormEditar(f => ({ ...f, data_fim: e.target.value }))} />
            </div>
            {modalEditar.plano_tipo === 'pacote' && (
              <div>
                <label style={S.label}>Aulas Utilizadas</label>
                <input type="number" min="0" style={S.input} value={formEditar.aulas_usadas ?? 0} onChange={e => setFormEditar(f => ({ ...f, aulas_usadas: parseInt(e.target.value) || 0 }))} />
              </div>
            )}
            <div style={{ gridColumn:'1/-1' }}>
              <label style={S.label}>Observação</label>
              <input style={S.input} value={formEditar.observacao || ''} onChange={e => setFormEditar(f => ({ ...f, observacao: e.target.value }))} />
            </div>
          </div>
        )}
        <div style={{ display:'flex', gap:'8px', marginTop:'16px', justifyContent:'flex-end' }}>
          <button style={S.btn('#64748b', true)} onClick={() => setModalEditar(null)}>Cancelar</button>
          <button style={S.btn()} onClick={salvarEdicao}>Salvar</button>
        </div>
      </Modal>
    </div>
  );
};

// ================================================================
// PLANOS (CRUD)
// ================================================================
const Planos = ({ createApi }) => {
  const [lista, setLista] = useState([]);
  const [msg, setMsg] = useState(null);
  const [modal, setModal] = useState(null);
  const emptyForm = { nome:'', tipo:'mensalidade', valor:'', num_aulas:'', descricao:'', ativo:true };
  const [form, setForm] = useState(emptyForm);

  const api = createApi();

  const load = useCallback(async () => {
    const r = await api.get('/admin/financeiro/planos');
    setLista(r.data.planos || []);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { load(); }, [load]);

  const salvar = async () => {
    try {
      if (modal === 'novo') {
        await api.post('/admin/financeiro/planos', form);
        setMsg({ type:'success', text:'Plano criado!' });
      } else {
        await api.put(`/admin/financeiro/planos/${modal.id}`, form);
        setMsg({ type:'success', text:'Plano atualizado!' });
      }
      setModal(null);
      load();
    } catch (e) { setMsg({ type:'error', text: e.response?.data?.error || 'Erro' }); }
  };

  const excluir = async (id) => {
    if (!window.confirm('Excluir este plano?')) return;
    try {
      await api.delete(`/admin/financeiro/planos/${id}`);
      load();
    } catch (e) { setMsg({ type:'error', text: e.response?.data?.error || 'Não é possível excluir plano com alunos vinculados' }); }
  };

  const abrirEditar = (p) => { setForm({ nome:p.nome, tipo:p.tipo, valor:p.valor, num_aulas:p.num_aulas||'', descricao:p.descricao||'', ativo:p.ativo }); setModal(p); };
  const tipoLabel = { mensalidade:'Mensalidade', pacote:'Pacote', avulso:'Avulso' };

  return (
    <div>
      {msg && <div style={S.alert(msg.type)}>{msg.text}</div>}
      <div style={{ display:'flex', justifyContent:'flex-end', marginBottom:'12px' }}>
        <button style={S.btn()} onClick={() => { setForm(emptyForm); setModal('novo'); }}>+ Novo Plano</button>
      </div>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(240px,1fr))', gap:'12px' }}>
        {lista.map(p => (
          <div key={p.id} style={{ ...S.card, opacity: p.ativo ? 1 : 0.6, position:'relative', marginBottom:0 }}>
            {!p.ativo && <span style={{ ...S.badge('#374151','#f3f4f6'), position:'absolute', top:10, right:10 }}>Inativo</span>}
            <div style={{ fontSize:'11px', color:'#0f5a30', fontWeight:600, textTransform:'uppercase', marginBottom:'4px' }}>{tipoLabel[p.tipo] || p.tipo}</div>
            <div style={{ fontSize:'16px', fontWeight:700, marginBottom:'4px' }}>{p.nome}</div>
            <div style={{ fontSize:'22px', fontWeight:800, color:'#10b981', marginBottom:'8px' }}>{fmt(p.valor)}</div>
            {p.num_aulas && <div style={{ fontSize:'12px', color:'#64748b', marginBottom:'4px' }}>{p.num_aulas} aula(s)</div>}
            {p.descricao && <div style={{ fontSize:'12px', color:'#94a3b8', marginBottom:'10px' }}>{p.descricao}</div>}
            <div style={{ display:'flex', gap:'8px' }}>
              <button style={S.btnSm('#0f5a30')} onClick={() => abrirEditar(p)}>Editar</button>
              <button style={S.btnSm('#ef4444')} onClick={() => excluir(p.id)}>Excluir</button>
            </div>
          </div>
        ))}
      </div>

      <Modal isOpen={!!modal} onClose={() => setModal(null)} title={modal === 'novo' ? 'Novo Plano' : 'Editar Plano'}>
        <div style={S.formGrid}>
          <div style={{ gridColumn:'1/-1' }}>
            <label style={S.label}>Nome</label>
            <input style={S.input} value={form.nome} onChange={e => setForm(f => ({ ...f, nome: e.target.value }))} />
          </div>
          <div>
            <label style={S.label}>Tipo</label>
            <select style={S.select} value={form.tipo} onChange={e => setForm(f => ({ ...f, tipo: e.target.value }))}>
              <option value="mensalidade">Mensalidade</option>
              <option value="pacote">Pacote de Aulas</option>
              <option value="avulso">Avulso</option>
            </select>
          </div>
          <div>
            <label style={S.label}>Valor (R$)</label>
            <input type="number" step="0.01" style={S.input} value={form.valor} onChange={e => setForm(f => ({ ...f, valor: e.target.value }))} />
          </div>
          {form.tipo !== 'mensalidade' && (
            <div>
              <label style={S.label}>Nº de Aulas</label>
              <input type="number" style={S.input} value={form.num_aulas} onChange={e => setForm(f => ({ ...f, num_aulas: e.target.value }))} />
            </div>
          )}
          <div style={{ gridColumn:'1/-1' }}>
            <label style={S.label}>Descrição</label>
            <input style={S.input} value={form.descricao} onChange={e => setForm(f => ({ ...f, descricao: e.target.value }))} />
          </div>
          {modal !== 'novo' && (
            <div>
              <label style={{ ...S.label, display:'flex', alignItems:'center', gap:'8px', cursor:'pointer' }}>
                <input type="checkbox" checked={form.ativo} onChange={e => setForm(f => ({ ...f, ativo: e.target.checked }))} />
                Plano ativo
              </label>
            </div>
          )}
        </div>
        <div style={{ display:'flex', gap:'8px', marginTop:'16px', justifyContent:'flex-end' }}>
          <button style={S.btn('#64748b', true)} onClick={() => setModal(null)}>Cancelar</button>
          <button style={S.btn()} onClick={salvar}>Salvar</button>
        </div>
      </Modal>
    </div>
  );
};

// ================================================================
// DESPESAS
// ================================================================
const Despesas = ({ createApi, isMobile }) => {
  const [lista, setLista] = useState([]);
  const [msg, setMsg] = useState(null);
  const [modal, setModal] = useState(null);
  const [filtroMes, setFiltroMes] = useState(new Date().getMonth() + 1);
  const [filtroAno, setFiltroAno] = useState(new Date().getFullYear());
  const [filtroStatus, setFiltroStatus] = useState('');
  const emptyForm = { descricao:'', valor:'', categoria:'aluguel', data_despesa:new Date().toISOString().split('T')[0], data_vencimento:'', status:'pendente', observacao:'' };
  const [form, setForm] = useState(emptyForm);
  const [totalFiltrado, setTotalFiltrado] = useState(0);

  const api = createApi();

  const load = useCallback(async () => {
    const params = new URLSearchParams({ mes: filtroMes, ano: filtroAno });
    if (filtroStatus) params.set('status', filtroStatus);
    const r = await api.get(`/admin/financeiro/despesas?${params}`);
    const items = r.data.despesas || [];
    setLista(items);
    setTotalFiltrado(items.reduce((s, d) => s + parseFloat(d.valor || 0), 0));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtroMes, filtroAno, filtroStatus]);

  useEffect(() => { load(); }, [load]);

  const salvar = async () => {
    try {
      if (modal === 'nova') {
        await api.post('/admin/financeiro/despesas', form);
        setMsg({ type:'success', text:'Despesa registrada!' });
      } else {
        await api.put(`/admin/financeiro/despesas/${modal.id}`, form);
        setMsg({ type:'success', text:'Despesa atualizada!' });
      }
      setModal(null);
      load();
    } catch (e) { setMsg({ type:'error', text: e.response?.data?.error || 'Erro' }); }
  };

  const excluir = async (id) => {
    if (!window.confirm('Excluir esta despesa?')) return;
    await api.delete(`/admin/financeiro/despesas/${id}`);
    load();
  };

  const marcarPago = async (d) => {
    await api.put(`/admin/financeiro/despesas/${d.id}`, { status:'pago' });
    load();
  };

  const abrirEditar = (d) => {
    setForm({ descricao:d.descricao, valor:d.valor, categoria:d.categoria, data_despesa:d.data_despesa?.split('T')[0]||'', data_vencimento:d.data_vencimento?.split('T')[0]||'', status:d.status, observacao:d.observacao||'' });
    setModal(d);
  };

  return (
    <div>
      {msg && <div style={S.alert(msg.type)}>{msg.text}</div>}

      <FiltroBar
        isMobile={isMobile}
        left={<>
          <select style={{ ...S.select, flex:1, minWidth:'110px', maxWidth:'170px' }} value={filtroMes} onChange={e => setFiltroMes(parseInt(e.target.value))}>
            {MESES_NOMES.map((n,i) => <option key={i+1} value={i+1}>{n}</option>)}
          </select>
          <AnoInput value={filtroAno} onChange={setFiltroAno} />
          <select style={{ ...S.select, flex:1, minWidth:'100px', maxWidth:'140px' }} value={filtroStatus} onChange={e => setFiltroStatus(e.target.value)}>
            <option value="">Todos</option>
            <option value="pendente">Pendente</option>
            <option value="pago">Pago</option>
          </select>
          <span style={{ color:'#ef4444', fontWeight:700, whiteSpace:'nowrap' }}>Total: {fmt(totalFiltrado)}</span>
        </>}
        right={<>
          <button style={{ ...S.btn('#64748b', true), flex: isMobile ? 1 : 'none' }} onClick={() => exportarCSV(createApi)('despesas')}>⬇ CSV</button>
          <button style={{ ...S.btn(), flex: isMobile ? 1 : 'none' }} onClick={() => { setForm(emptyForm); setModal('nova'); }}>+ Nova Despesa</button>
        </>}
      />

      <TabelaScroll>
        <table style={S.table}>
          <thead><tr>{['Descrição','Categoria','Valor','Data','Vencimento','Status','Ações'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
          <tbody>
            {lista.length === 0 && <tr><td colSpan={7} style={{ ...S.td, textAlign:'center', color:'#94a3b8', padding:'30px' }}>Nenhuma despesa encontrada</td></tr>}
            {lista.map(d => (
              <tr key={d.id}>
                <td style={{ ...S.td, fontWeight:600 }}>{d.descricao}</td>
                <td style={S.td}><span style={S.badge('#475569','#f1f5f9')}>{CATEGORIAS_DESPESA.find(c => c.value === d.categoria)?.label || d.categoria}</span></td>
                <td style={{ ...S.td, fontWeight:700, color:'#ef4444' }}>{fmt(d.valor)}</td>
                <td style={S.td}>{fmtDate(d.data_despesa)}</td>
                <td style={S.td}>{fmtDate(d.data_vencimento)}</td>
                <td style={S.td}>{statusBadge(d.status)}</td>
                <td style={S.td}>
                  <div style={{ display:'flex', gap:'4px' }}>
                    {d.status === 'pendente' && <button style={S.btnSm('#10b981')} onClick={() => marcarPago(d)}>✓</button>}
                    <button style={S.btnSm('#0f5a30')} onClick={() => abrirEditar(d)}>✏</button>
                    <button style={S.btnSm('#ef4444')} onClick={() => excluir(d.id)}>🗑</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </TabelaScroll>

      <Modal isOpen={!!modal} onClose={() => setModal(null)} title={modal === 'nova' ? 'Nova Despesa' : 'Editar Despesa'}>
        <div style={S.formGrid}>
          <div style={{ gridColumn:'1/-1' }}>
            <label style={S.label}>Descrição</label>
            <input style={S.input} value={form.descricao} onChange={e => setForm(f => ({ ...f, descricao: e.target.value }))} />
          </div>
          <div>
            <label style={S.label}>Valor (R$)</label>
            <input type="number" step="0.01" style={S.input} value={form.valor} onChange={e => setForm(f => ({ ...f, valor: e.target.value }))} />
          </div>
          <div>
            <label style={S.label}>Categoria</label>
            <select style={S.select} value={form.categoria} onChange={e => setForm(f => ({ ...f, categoria: e.target.value }))}>
              {CATEGORIAS_DESPESA.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
          </div>
          <div>
            <label style={S.label}>Data da Despesa</label>
            <input type="date" style={S.input} value={form.data_despesa} onChange={e => setForm(f => ({ ...f, data_despesa: e.target.value }))} />
          </div>
          <div>
            <label style={S.label}>Vencimento</label>
            <input type="date" style={S.input} value={form.data_vencimento} onChange={e => setForm(f => ({ ...f, data_vencimento: e.target.value }))} />
          </div>
          <div>
            <label style={S.label}>Status</label>
            <select style={S.select} value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))}>
              <option value="pendente">Pendente</option>
              <option value="pago">Pago</option>
            </select>
          </div>
          <div style={{ gridColumn:'1/-1' }}>
            <label style={S.label}>Observação</label>
            <input style={S.input} value={form.observacao} onChange={e => setForm(f => ({ ...f, observacao: e.target.value }))} />
          </div>
        </div>
        <div style={{ display:'flex', gap:'8px', marginTop:'16px', justifyContent:'flex-end' }}>
          <button style={S.btn('#64748b', true)} onClick={() => setModal(null)}>Cancelar</button>
          <button style={S.btn()} onClick={salvar}>Salvar</button>
        </div>
      </Modal>
    </div>
  );
};

// ================================================================
// RELATÓRIO ANUAL
// ================================================================
const Relatorio = ({ createApi, isMobile }) => {
  const [data, setData] = useState(null);
  const [ano, setAno] = useState(new Date().getFullYear());

  const api = createApi();

  const load = useCallback(async () => {
    const r = await api.get(`/admin/financeiro/relatorio?ano=${ano}`);
    setData(r.data);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ano]);

  useEffect(() => { load(); }, [load]);

  if (!data) return <div style={{ textAlign:'center', padding:'40px', color:'#94a3b8' }}>Carregando...</div>;

  const maxReceita = Math.max(...data.meses.map(m => m.receita_paga), 1);
  const valStyle = (color) => ({
    fontSize: isMobile ? '15px' : '20px',
    fontWeight: 800, margin: '4px 0 2px',
    color, wordBreak: 'break-word', lineHeight: 1.2,
  });
  const cardStyle = (color) => ({
    ...S.statCard(color),
    padding: isMobile ? '10px 12px' : '14px 16px',
    minWidth: 0, overflow: 'hidden',
  });

  return (
    <div>
      <FiltroBar
        isMobile={isMobile}
        left={<>
          <span style={{ fontWeight:600, whiteSpace:'nowrap' }}>Ano:</span>
          <AnoInput value={ano} onChange={setAno} />
          <button style={S.btn()} onClick={load}>Atualizar</button>
        </>}
      />

      {/* Cards de totais — 1 coluna por card, sempre cabem */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'8px', marginBottom:'16px' }}>
        <div style={cardStyle('#10b981')}>
          <div style={S.statLabel}>Receita {ano}</div>
          <div style={valStyle('#10b981')}>{fmt(data.totais.receita)}</div>
        </div>
        <div style={cardStyle('#ef4444')}>
          <div style={S.statLabel}>Despesas {ano}</div>
          <div style={valStyle('#ef4444')}>{fmt(data.totais.despesas)}</div>
        </div>
        <div style={cardStyle(data.totais.lucro >= 0 ? '#0f5a30' : '#f59e0b')}>
          <div style={S.statLabel}>Lucro {ano}</div>
          <div style={valStyle(data.totais.lucro >= 0 ? '#0f5a30' : '#f59e0b')}>{fmt(data.totais.lucro)}</div>
        </div>
      </div>

      {/* Gráfico de barras — sem label de valor no mobile */}
      <div style={S.card}>
        <div style={S.title}>Receita Mensal</div>
        <div style={{ display:'flex', alignItems:'flex-end', gap: isMobile ? '2px' : '4px', height:'100px' }}>
          {data.meses.map(m => {
            const pct = Math.round((m.receita_paga / maxReceita) * 100);
            return (
              <div key={m.mes} style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', gap:'2px', minWidth:0 }}>
                {!isMobile && (
                  <div style={{ fontSize:'8px', color:'#94a3b8', fontWeight:600, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap', width:'100%', textAlign:'center' }}>
                    {pct > 15 ? fmt(m.receita_paga).replace('R$ ','').replace('R$','').trim() : ''}
                  </div>
                )}
                <div style={{ width:'100%', flex:1, display:'flex', alignItems:'flex-end' }}>
                  <div style={{ width:'100%', background: pct > 0 ? '#0f5a30' : '#f1f5f9', height:`${Math.max(pct,4)}%`, borderRadius:'3px 3px 0 0', transition:'height .3s' }} />
                </div>
                <div style={{ fontSize:'8px', color:'#94a3b8', whiteSpace:'nowrap' }}>{MESES_NOMES[m.mes-1].slice(0,3)}</div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Tabela — scroll horizontal, colunas compactas no mobile */}
      <TabelaScroll>
        <table style={S.table}>
          <thead>
            <tr>
              {(isMobile
                ? ['Mês','Receita','Despesa','Lucro']
                : ['Mês','Receita','Despesas','Lucro','Mensalidades']
              ).map(h => <th key={h} style={S.th}>{h}</th>)}
            </tr>
          </thead>
          <tbody>
            {data.meses.map(m => (
              <tr key={m.mes}>
                <td style={{ ...S.td, fontWeight:600, whiteSpace:'nowrap' }}>{isMobile ? MESES_NOMES[m.mes-1].slice(0,3) : MESES_NOMES[m.mes-1]}</td>
                <td style={{ ...S.td, color:'#10b981', fontWeight:700, whiteSpace:'nowrap' }}>{fmt(m.receita_paga)}</td>
                <td style={{ ...S.td, color:'#ef4444', fontWeight:700, whiteSpace:'nowrap' }}>{fmt(m.despesas)}</td>
                <td style={{ ...S.td, fontWeight:700, whiteSpace:'nowrap', color: m.lucro >= 0 ? '#0f5a30' : '#f59e0b' }}>{fmt(m.lucro)}</td>
                {!isMobile && <td style={S.td}>{m.mensalidades_total > 0 ? `${m.mensalidades_total}/${m.mensalidades_pagas}/${m.mensalidades_pendentes}` : '—'}</td>}
              </tr>
            ))}
            <tr style={{ background:'#f8fafc', fontWeight:800 }}>
              <td style={{ ...S.td, fontWeight:800 }}>TOTAL</td>
              <td style={{ ...S.td, color:'#10b981', fontWeight:800, whiteSpace:'nowrap' }}>{fmt(data.totais.receita)}</td>
              <td style={{ ...S.td, color:'#ef4444', fontWeight:800, whiteSpace:'nowrap' }}>{fmt(data.totais.despesas)}</td>
              <td style={{ ...S.td, fontWeight:800, whiteSpace:'nowrap', color: data.totais.lucro >= 0 ? '#0f5a30' : '#f59e0b' }}>{fmt(data.totais.lucro)}</td>
              {!isMobile && <td style={S.td}>—</td>}
            </tr>
          </tbody>
        </table>
      </TabelaScroll>
    </div>
  );
};

// ================================================================
// PACOTES
// ================================================================
const Pacotes = ({ createApi, isMobile }) => {
  const [lista, setLista] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const api = createApi();
      const r = await api.get('/admin/financeiro/pacotes-creditos');
      setLista(r.data.pacotes || []);
    } catch { /* silently */ }
    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) return <div style={{ textAlign:'center', padding:'40px', color:'#94a3b8' }}>Carregando...</div>;

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'12px' }}>
        <div style={S.title}>Créditos de Pacote</div>
        <button style={S.btn()} onClick={load}>↻ Atualizar</button>
      </div>
      {lista.length === 0
        ? <div style={{ ...S.card, textAlign:'center', color:'#94a3b8', padding:'30px' }}>Nenhum pacote ativo</div>
        : (
          <TabelaScroll>
            <table style={S.table}>
              <thead>
                <tr>{['Aluno','Plano','Aulas','Usadas','Restantes','Início','Situação'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {lista.map(p => {
                  const pct = p.num_aulas ? Math.round((p.aulas_usadas / p.num_aulas) * 100) : 0;
                  const cor = p.aulas_restantes === 0 ? '#ef4444' : p.aulas_restantes <= 2 ? '#f59e0b' : '#10b981';
                  return (
                    <tr key={p.id}>
                      <td style={S.td}><div style={{ fontWeight:600 }}>{p.aluno_nome}</div><div style={{ fontSize:'11px', color:'#94a3b8' }}>{p.aluno_email}</div></td>
                      <td style={S.td}>{p.plano_nome}</td>
                      <td style={S.td}>{p.num_aulas}</td>
                      <td style={S.td}>{p.aulas_usadas}</td>
                      <td style={S.td}>
                        <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
                          <span style={{ fontWeight:700, color:cor }}>{p.aulas_restantes}</span>
                          <div style={{ flex:1, minWidth:'60px', height:'6px', borderRadius:'3px', background:'#e2e8f0', overflow:'hidden' }}>
                            <div style={{ width:`${pct}%`, height:'100%', background:cor, transition:'width .3s' }} />
                          </div>
                        </div>
                      </td>
                      <td style={S.td}>{fmtDate(p.data_inicio)}</td>
                      <td style={S.td}>{statusBadge(p.status)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </TabelaScroll>
        )
      }
    </div>
  );
};

// ================================================================
// PARCERIAS
// ================================================================
const Parcerias = ({ createApi, isMobile }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mes, setMes] = useState(new Date().getMonth() + 1);
  const [ano, setAno] = useState(new Date().getFullYear());

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const api = createApi();
      const r = await api.get(`/admin/financeiro/parcerias?mes=${mes}&ano=${ano}`);
      setData(r.data);
    } catch { /* silently */ }
    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mes, ano]);

  useEffect(() => { load(); }, [load]);

  const ORIGEM_LABEL = { wellhub:'Wellhub', totalpass:'Total Pass' };

  return (
    <div>
      <FiltroBar
        isMobile={isMobile}
        left={<>
          <span style={{ fontWeight:600, color:'#475569', whiteSpace:'nowrap' }}>Referência:</span>
          <select style={{ ...S.select, flex:1, minWidth:'120px', maxWidth:'180px' }} value={mes} onChange={e => setMes(parseInt(e.target.value))}>
            {MESES_NOMES.map((n,i) => <option key={i+1} value={i+1}>{n}</option>)}
          </select>
          <AnoInput value={ano} onChange={setAno} />
          <button style={S.btn()} onClick={load}>Atualizar</button>
        </>}
      />

      {loading && <div style={{ textAlign:'center', padding:'40px', color:'#94a3b8' }}>Carregando...</div>}

      {data && (
        <>
          {/* Resumo por parceiro */}
          {data.resumo?.length > 0 && (
            <div style={{ ...S.grid4, marginBottom:'16px' }}>
              {data.resumo.map(r => (
                <div key={r.origem} style={S.statCard('#7c3aed')}>
                  <div style={{ marginBottom:'4px' }}>{origemBadge(r.origem)}</div>
                  <div style={{ fontSize:'20px', fontWeight:800, color:'#1e293b' }}>{r.aulas_total}</div>
                  <div style={{ fontSize:'11px', color:'#94a3b8' }}>{r.alunos} aluno(s) — {MESES_NOMES[mes-1]}</div>
                </div>
              ))}
            </div>
          )}

          {data.alunos?.length === 0
            ? <div style={{ ...S.card, textAlign:'center', color:'#94a3b8', padding:'30px' }}>Nenhum aluno de parceria com aulas em {MESES_NOMES[mes-1]}/{ano}</div>
            : (
              <TabelaScroll>
                <table style={S.table}>
                  <thead>
                    <tr>{['Aluno','Parceria','Telefone','Aulas no Mês'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr>
                  </thead>
                  <tbody>
                    {data.alunos?.map(a => (
                      <tr key={a.id}>
                        <td style={S.td}><div style={{ fontWeight:600 }}>{a.nome}</div><div style={{ fontSize:'11px', color:'#94a3b8' }}>{a.email || '—'}</div></td>
                        <td style={S.td}>{origemBadge(a.origem)}</td>
                        <td style={S.td}>{a.telefone || '—'}</td>
                        <td style={{ ...S.td, fontWeight:700, fontSize:'16px' }}>{a.aulas_mes}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </TabelaScroll>
            )
          }
        </>
      )}
    </div>
  );
};

// ================================================================
// INADIMPLÊNCIA DETALHADA
// ================================================================
const Inadimplencia = ({ createApi, isMobile }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [enviando, setEnviando] = useState(false);
  const [msg, setMsg] = useState(null);
  const [faixa, setFaixa] = useState('lista');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const api = createApi();
      const r = await api.get('/admin/financeiro/inadimplencia');
      setData(r.data);
    } catch { /* silently */ }
    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => { load(); }, [load]);

  const enviarLembretes = async () => {
    setEnviando(true);
    try {
      const api = createApi();
      const r = await api.post('/admin/financeiro/enviar-lembretes');
      setMsg({ type:'success', text:`${r.data.enviados} lembrete(s) enviado(s)!` });
      load();
    } catch { setMsg({ type:'error', text:'Erro ao enviar lembretes' }); }
    setEnviando(false);
    setTimeout(() => setMsg(null), 4000);
  };

  if (loading) return <div style={{ textAlign:'center', padding:'40px', color:'#94a3b8' }}>Carregando...</div>;
  if (!data) return null;

  const FAIXAS = [
    { id: 'lista', label: 'Todos', cor: '#64748b' },
    { id: 'a_vencer', label: 'A vencer', cor: '#0ea5e9' },
    { id: 'ate_15', label: 'Até 15 dias', cor: '#f59e0b' },
    { id: 'ate_30', label: '16–30 dias', cor: '#ef4444' },
    { id: 'mais_30', label: '+30 dias', cor: '#7f1d1d' },
  ];

  const lista = faixa === 'lista' ? data.lista : (data.faixas[faixa] || []);
  const totalFaixa = lista.reduce((s, r) => s + parseFloat(r.valor || 0), 0);

  return (
    <div>
      {msg && <div style={S.alert(msg.type)}>{msg.text}</div>}

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'12px', flexWrap:'wrap', gap:'8px' }}>
        <div style={S.title}>Inadimplência — {data.total} cobrança(s) pendente(s)</div>
        <button style={S.btn('#f59e0b')} onClick={enviarLembretes} disabled={enviando}>
          {enviando ? 'Enviando...' : '📧 Enviar Lembretes'}
        </button>
      </div>

      {/* Resumo por faixa */}
      <div style={{ display:'flex', gap:'8px', flexWrap:'wrap', marginBottom:'16px' }}>
        {FAIXAS.map(f => {
          const qtd = f.id === 'lista' ? data.total : (data.faixas[f.id]?.length || 0);
          return (
            <button key={f.id} onClick={() => setFaixa(f.id)} style={{
              ...S.statCard(f.cor), flex:'1 1 100px', minWidth:'80px', cursor:'pointer',
              border: faixa === f.id ? `2px solid ${f.cor}` : '1px solid #e2e8f0',
              background: faixa === f.id ? f.cor + '15' : '#fff',
            }}>
              <div style={{ fontSize:'10px', color:'#64748b', textTransform:'uppercase', letterSpacing:'.04em' }}>{f.label}</div>
              <div style={{ fontSize:'20px', fontWeight:800, color: f.cor }}>{qtd}</div>
            </button>
          );
        })}
      </div>

      {lista.length === 0
        ? <div style={{ ...S.card, textAlign:'center', color:'#94a3b8', padding:'30px' }}>Nenhuma cobrança nesta faixa</div>
        : (
          <>
            <div style={{ marginBottom:'8px', fontSize:'13px', color:'#475569' }}>
              Total em aberto: <strong>{fmt(totalFaixa)}</strong>
            </div>
            <TabelaScroll>
              <table style={S.table}>
                <thead>
                  <tr>{['Aluno','Plano','Valor','Vencimento','Dias em atraso','Status','Lembrete'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr>
                </thead>
                <tbody>
                  {lista.map(r => (
                    <tr key={r.id}>
                      <td style={S.td}>
                        <div style={{ fontWeight:600 }}>{r.aluno_nome}</div>
                        <div style={{ fontSize:'11px', color:'#94a3b8' }}>{r.aluno_email || r.aluno_telefone || '—'}</div>
                      </td>
                      <td style={S.td}>{r.plano_nome || '—'}</td>
                      <td style={{ ...S.td, fontWeight:700 }}>{fmt(r.valor)}</td>
                      <td style={S.td}>{fmtDate(r.data_vencimento)}</td>
                      <td style={S.td}>
                        {r.dias_atraso !== null
                          ? <span style={{ fontWeight:700, color: r.dias_atraso > 30 ? '#7f1d1d' : r.dias_atraso > 15 ? '#ef4444' : '#f59e0b' }}>{Math.round(r.dias_atraso)}d</span>
                          : <span style={{ color:'#0ea5e9' }}>A vencer</span>}
                      </td>
                      <td style={S.td}>{statusBadge(r.status)}</td>
                      <td style={S.td}>{r.lembrete_enviado ? <span style={{ fontSize:'11px', color:'#94a3b8' }}>Enviado {fmtDate(r.lembrete_enviado)}</span> : <span style={{ fontSize:'11px', color:'#10b981' }}>Não enviado</span>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </TabelaScroll>
          </>
        )
      }
    </div>
  );
};

// ================================================================
// EXTRATO POR ALUNO
// ================================================================
const ExtratoAluno = ({ createApi, isMobile }) => {
  const [alunos, setAlunos] = useState([]);
  const [alunoSel, setAlunoSel] = useState('');
  const [extrato, setExtrato] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const api = createApi();
    api.get('/admin/usuarios').then(r => setAlunos(r.data || [])).catch(() => {});
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const buscar = async () => {
    if (!alunoSel) return;
    setLoading(true);
    try {
      const api = createApi();
      const r = await api.get(`/admin/financeiro/extrato/${alunoSel}`);
      setExtrato(r.data);
    } catch { setExtrato(null); }
    setLoading(false);
  };

  return (
    <div>
      <div style={{ display:'flex', gap:'8px', marginBottom:'16px', flexWrap:'wrap' }}>
        <select style={{ ...S.select, flex:1 }} value={alunoSel} onChange={e => setAlunoSel(e.target.value)}>
          <option value="">Selecione um aluno...</option>
          {alunos.map(a => <option key={a.id} value={a.id}>{a.nome} {a.email ? `— ${a.email}` : ''}</option>)}
        </select>
        <button style={S.btn()} onClick={buscar} disabled={!alunoSel || loading}>
          {loading ? 'Buscando...' : 'Ver Extrato'}
        </button>
        {extrato && (
          <button style={S.btn('#64748b', true)} onClick={() => exportarCSV(createApi)('receitas', { aluno_id: alunoSel })}>⬇ CSV</button>
        )}
      </div>

      {extrato && (
        <>
          {/* Resumo */}
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(130px,1fr))', gap:'10px', marginBottom:'16px' }}>
            <div style={S.statCard('#10b981')}>
              <div style={S.statLabel}>Total Pago</div>
              <div style={{ ...S.statVal, color:'#10b981', fontSize:'16px' }}>{fmt(extrato.resumo.total_pago)}</div>
            </div>
            <div style={S.statCard('#f59e0b')}>
              <div style={S.statLabel}>A Receber</div>
              <div style={{ ...S.statVal, color:'#f59e0b', fontSize:'16px' }}>{fmt(extrato.resumo.total_pendente)}</div>
            </div>
            <div style={S.statCard('#0f5a30')}>
              <div style={S.statLabel}>Aulas Agendadas</div>
              <div style={{ ...S.statVal, color:'#0f5a30', fontSize:'16px' }}>{extrato.resumo.total_aulas}</div>
            </div>
            <div style={S.statCard('#0ea5e9')}>
              <div style={S.statLabel}>Origem</div>
              <div style={{ marginTop:'4px' }}>{origemBadge(extrato.aluno.origem || 'regular')}</div>
            </div>
          </div>

          {/* Planos */}
          {extrato.planos.length > 0 && (
            <div style={{ ...S.card, marginBottom:'12px' }}>
              <div style={S.title}>Histórico de Planos</div>
              <TabelaScroll>
                <table style={S.table}>
                  <thead><tr>{['Plano','Tipo','Valor','Início','Fim','Status','Aulas usadas'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
                  <tbody>
                    {extrato.planos.map(p => (
                      <tr key={p.id}>
                        <td style={S.td}>{p.plano_nome}</td>
                        <td style={S.td}>{tipoBadge(p.plano_tipo)}</td>
                        <td style={S.td}>{fmt(p.plano_valor)}</td>
                        <td style={S.td}>{fmtDate(p.data_inicio)}</td>
                        <td style={S.td}>{fmtDate(p.data_fim) || '—'}</td>
                        <td style={S.td}>{statusBadge(p.status)}</td>
                        <td style={S.td}>{p.plano_tipo === 'pacote' ? `${p.aulas_usadas}/${p.num_aulas}` : '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </TabelaScroll>
            </div>
          )}

          {/* Mensalidades */}
          <div style={S.card}>
            <div style={S.title}>Histórico Financeiro</div>
            <TabelaScroll>
              <table style={S.table}>
                <thead><tr>{['Mês','Tipo','Valor','Vencimento','Pagamento','Status'].map(h => <th key={h} style={S.th}>{h}</th>)}</tr></thead>
                <tbody>
                  {extrato.mensalidades.length === 0 && <tr><td colSpan={6} style={{ ...S.td, textAlign:'center', color:'#94a3b8' }}>Nenhum lançamento</td></tr>}
                  {extrato.mensalidades.map(m => (
                    <tr key={m.id}>
                      <td style={S.td}>{m.mes_referencia?.slice(0,7)}</td>
                      <td style={S.td}>{tipoBadge(m.tipo_receita || 'mensalidade')}</td>
                      <td style={{ ...S.td, fontWeight:700 }}>{fmt(m.valor)}</td>
                      <td style={S.td}>{fmtDate(m.data_vencimento)}</td>
                      <td style={S.td}>{fmtDate(m.data_pagamento)}</td>
                      <td style={S.td}>{statusBadge(m.status)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </TabelaScroll>
          </div>
        </>
      )}
    </div>
  );
};

// ================================================================
// PRODUTOS / SERVIÇOS
// ================================================================
const CATEGORIAS_PRODUTO = [
  { value: 'plano',       label: 'Plano de Aulas' },
  { value: 'pacote',      label: 'Pacote de Aulas' },
  { value: 'aula',        label: 'Aula Avulsa/Experimental' },
  { value: 'suplemento',  label: 'Suplemento' },
  { value: 'vestuario',   label: 'Vestuário/Acessório' },
  { value: 'equipamento', label: 'Equipamento' },
  { value: 'servico',     label: 'Serviço' },
  { value: 'outro',       label: 'Outro' },
];

const UNIDADES = [
  { value: 'un',    label: 'Unidade' },
  { value: 'mes',   label: 'Mês' },
  { value: 'aula',  label: 'Aula' },
  { value: 'hr',    label: 'Hora' },
  { value: 'kg',    label: 'Kg' },
];

const Produtos = ({ createApi, isMobile }) => {
  const [lista, setLista] = useState([]);
  const [msg, setMsg] = useState(null);
  const [modal, setModal] = useState(null);
  const emptyForm = { nome:'', descricao:'', valor:'', categoria:'servico', unidade:'un', ativo:true };
  const [form, setForm] = useState(emptyForm);
  const [filtroAtivo, setFiltroAtivo] = useState('true');

  const api = createApi();

  const load = useCallback(async () => {
    try {
      const r = await api.get(`/admin/financeiro/produtos?ativo=${filtroAtivo}`);
      setLista(r.data.produtos || []);
    } catch { /* silently */ }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtroAtivo]);

  useEffect(() => { load(); }, [load]);

  const salvar = async () => {
    if (!form.nome || form.valor === '') return setMsg({ type:'error', text:'Nome e valor são obrigatórios' });
    try {
      if (modal === 'novo') {
        await api.post('/admin/financeiro/produtos', form);
        setMsg({ type:'success', text:'Produto criado!' });
      } else {
        await api.put(`/admin/financeiro/produtos/${modal.id}`, form);
        setMsg({ type:'success', text:'Produto atualizado!' });
      }
      setModal(null); load();
    } catch (e) { setMsg({ type:'error', text: e.response?.data?.error || 'Erro' }); }
  };

  const excluir = async (id) => {
    if (!window.confirm('Excluir este produto?')) return;
    try {
      await api.delete(`/admin/financeiro/produtos/${id}`);
      load();
    } catch (e) { setMsg({ type:'error', text: e.response?.data?.error || 'Não é possível excluir — há receitas vinculadas. Desative-o.' }); }
  };

  const toggleAtivo = async (p) => {
    try {
      await api.put(`/admin/financeiro/produtos/${p.id}`, { ...p, ativo: !p.ativo });
      load();
    } catch { /* silently */ }
  };

  const abrirEditar = (p) => {
    setForm({ nome: p.nome, descricao: p.descricao||'', valor: p.valor, categoria: p.categoria, unidade: p.unidade||'un', ativo: p.ativo });
    setModal(p);
  };

  const catLabel = (c) => CATEGORIAS_PRODUTO.find(x => x.value === c)?.label || c;
  const COR_CAT = { plano:'#0f5a30', pacote:'#10b981', aula:'#0ea5e9', suplemento:'#f59e0b', vestuario:'#ec4899', equipamento:'#f97316', servico:'#8b5cf6', outro:'#64748b' };

  return (
    <div>
      {msg && <div style={S.alert(msg.type)}>{msg.text}</div>}

      <FiltroBar
        isMobile={isMobile}
        left={<>
          <select style={{ ...S.select, maxWidth:'160px' }} value={filtroAtivo} onChange={e => setFiltroAtivo(e.target.value)}>
            <option value="true">Ativos</option>
            <option value="false">Inativos</option>
          </select>
        </>}
        right={<button style={S.btn()} onClick={() => { setForm(emptyForm); setModal('novo'); }}>+ Novo Produto</button>}
      />

      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(240px,1fr))', gap:'12px' }}>
        {lista.length === 0 && <div style={{ gridColumn:'1/-1', ...S.card, textAlign:'center', color:'#94a3b8', padding:'30px' }}>Nenhum produto encontrado</div>}
        {lista.map(p => {
          const cor = COR_CAT[p.categoria] || '#64748b';
          return (
            <div key={p.id} style={{ ...S.card, opacity: p.ativo ? 1 : 0.55, position:'relative', marginBottom:0, borderTop:`3px solid ${cor}` }}>
              <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:'6px' }}>
                <span style={S.badge(cor, cor + '18')}>{catLabel(p.categoria)}</span>
                {p.unidade && p.unidade !== 'un' && <span style={{ fontSize:'11px', color:'#94a3b8' }}>/{p.unidade}</span>}
              </div>
              <div style={{ fontSize:'15px', fontWeight:700, color:'#1e293b', marginBottom:'4px' }}>{p.nome}</div>
              <div style={{ fontSize:'22px', fontWeight:800, color:'#10b981', marginBottom:'6px' }}>{fmt(p.valor)}</div>
              {p.descricao && <div style={{ fontSize:'12px', color:'#94a3b8', marginBottom:'10px', lineHeight:'1.4' }}>{p.descricao}</div>}
              <div style={{ display:'flex', gap:'6px', flexWrap:'wrap' }}>
                <button style={S.btnSm('#0f5a30')} onClick={() => abrirEditar(p)}>Editar</button>
                <button style={S.btnSm(p.ativo ? '#f59e0b' : '#10b981')} onClick={() => toggleAtivo(p)}>{p.ativo ? 'Desativar' : 'Ativar'}</button>
                <button style={S.btnSm('#ef4444')} onClick={() => excluir(p.id)}>Excluir</button>
              </div>
            </div>
          );
        })}
      </div>

      <Modal isOpen={!!modal} onClose={() => setModal(null)} title={modal === 'novo' ? 'Novo Produto/Serviço' : 'Editar Produto/Serviço'} width="560px">
        <div style={S.formGrid}>
          <div style={{ gridColumn:'1/-1' }}>
            <label style={S.label}>Nome *</label>
            <input style={S.input} value={form.nome} onChange={e => setForm(f => ({ ...f, nome: e.target.value }))} placeholder="Ex: Aula Avulsa, Camiseta Allma..." />
          </div>
          <div style={{ gridColumn:'1/-1' }}>
            <label style={S.label}>Descrição</label>
            <input style={S.input} value={form.descricao} onChange={e => setForm(f => ({ ...f, descricao: e.target.value }))} placeholder="Detalhes do produto ou serviço" />
          </div>
          <div>
            <label style={S.label}>Categoria</label>
            <select style={S.select} value={form.categoria} onChange={e => setForm(f => ({ ...f, categoria: e.target.value }))}>
              {CATEGORIAS_PRODUTO.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
            </select>
          </div>
          <div>
            <label style={S.label}>Valor (R$) *</label>
            <input type="number" step="0.01" min="0" style={S.input} value={form.valor} onChange={e => setForm(f => ({ ...f, valor: e.target.value }))} placeholder="0,00" />
          </div>
          <div>
            <label style={S.label}>Unidade</label>
            <select style={S.select} value={form.unidade} onChange={e => setForm(f => ({ ...f, unidade: e.target.value }))}>
              {UNIDADES.map(u => <option key={u.value} value={u.value}>{u.label}</option>)}
            </select>
          </div>
          <div style={{ display:'flex', alignItems:'center', gap:'8px', paddingTop:'20px' }}>
            <input type="checkbox" id="prod-ativo" checked={form.ativo} onChange={e => setForm(f => ({ ...f, ativo: e.target.checked }))} />
            <label htmlFor="prod-ativo" style={{ fontSize:'13px', color:'#475569', cursor:'pointer' }}>Produto ativo</label>
          </div>
        </div>
        <div style={{ display:'flex', gap:'8px', justifyContent:'flex-end', marginTop:'20px' }}>
          <button style={S.btn('#64748b', true)} onClick={() => setModal(null)}>Cancelar</button>
          <button style={S.btn()} onClick={salvar}>Salvar</button>
        </div>
      </Modal>
    </div>
  );
};

// ================================================================
// AJUDA / MANUAL
// ================================================================
const AJUDA = [
  {
    aba: 'Dashboard',
    icon: '📊',
    desc: 'Visão geral do mês: receita recebida, despesas, lucro e inadimplentes.',
    itens: [
      'Selecione mês e ano e clique em Atualizar.',
      'Receita por Tipo mostra o total pago separado por Mensalidade, Avulso, Experimental e Parceria.',
      'Alunos por Origem conta quantos são regulares, Wellhub ou Total Pass.',
      'A tabela Pendentes/Atrasados lista cobranças em aberto do mês.',
    ]
  },
  {
    aba: 'Receitas',
    icon: '💳',
    desc: 'Gerencia todos os lançamentos financeiros de alunos.',
    itens: [
      'Filtre por mês/ano e status (pendente, pago, atrasado).',
      'O badge colorido indica o Tipo de Receita: Mensalidade, Avulso, Experimental, Pacote ou Parceria.',
      '+ Nova: cria um lançamento manual escolhendo o tipo. Para Mensalidade, apenas um lançamento por aluno/mês é permitido.',
      '⚡ Gerar lote: gera mensalidades para todos os alunos com plano ativo no mês selecionado, ignorando quem já tem cobrança.',
      'Clique no botão de pagamento (R$) para registrar data e método de pagamento.',
      'Aulas avulsas e experimentais geram cobranças automáticas ao confirmar o agendamento.',
    ]
  },
  {
    aba: 'Alunos & Planos',
    icon: '👤',
    desc: 'Vincula alunos a planos e controla o status do contrato.',
    itens: [
      '+ Vincular Plano: associa um aluno a um plano. O plano anterior é automaticamente cancelado.',
      'Você pode cancelar um plano ativo clicando em Cancelar.',
      'Origem do aluno (Regular, Wellhub, Total Pass) é definida no cadastro de usuário.',
    ]
  },
  {
    aba: 'Pacotes',
    icon: '🎟️',
    desc: 'Mostra o saldo de créditos de pacotes ativos.',
    itens: [
      'Exibe pacotes de aulas com créditos restantes em barra de progresso.',
      'Amarelo = ≤2 aulas restantes. Vermelho = sem aulas. Verde = OK.',
      'A cada agendamento confirmado, uma aula é automaticamente descontada do pacote.',
      'Quando o pacote zera, o status muda para Expirado automaticamente.',
    ]
  },
  {
    aba: 'Parcerias',
    icon: '🤝',
    desc: 'Relatório mensal de frequência dos alunos Wellhub e Total Pass.',
    itens: [
      'Selecione mês e ano para ver quantas aulas cada aluno de parceria realizou.',
      'Use este relatório para emitir o faturamento para a operadora (Wellhub/Total Pass).',
      'Para cadastrar um aluno de parceria, defina a Origem ao criar ou editar o usuário.',
      'Alunos de parceria não geram cobrança automática — o faturamento é feito pela operadora.',
    ]
  },
  {
    aba: 'Planos',
    icon: '📋',
    desc: 'Cadastro dos tipos de planos oferecidos.',
    itens: [
      'Tipos disponíveis: Mensalidade (cobrança mensal), Pacote (créditos de aulas), Avulso (cobrança por aula), Experimental (aula trial), Parceria (Wellhub/Total Pass).',
      'Informe o número de aulas apenas para Pacotes.',
      'Desative planos obsoletos ao invés de deletar para preservar o histórico.',
    ]
  },
  {
    aba: 'Despesas',
    icon: '💸',
    desc: 'Controle de gastos operacionais.',
    itens: [
      'Categorize as despesas (aluguel, energia, salário etc.) para facilitar análises.',
      'Despesas são consideradas no cálculo do Lucro Líquido no Dashboard.',
    ]
  },
  {
    aba: 'Relatório',
    icon: '📈',
    desc: 'Evolução financeira anual mês a mês.',
    itens: [
      'Visualize receita, despesas e lucro de cada mês do ano selecionado.',
      'Ideal para planejamento e análise de sazonalidade.',
    ]
  },
];

const Ajuda = ({ onClose }) => (
  <Modal isOpen onClose={onClose} title="Manual — Gestão Financeira" width="680px">
    <div style={{ maxHeight:'70vh', overflowY:'auto', paddingRight:'4px' }}>
      {AJUDA.map(a => (
        <div key={a.aba} style={{ marginBottom:'20px' }}>
          <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'6px' }}>
            <span style={{ fontSize:'18px' }}>{a.icon}</span>
            <span style={{ fontWeight:700, fontSize:'14px', color:'#1e293b' }}>{a.aba}</span>
            <span style={{ fontSize:'12px', color:'#64748b' }}>— {a.desc}</span>
          </div>
          <ul style={{ margin:'0 0 0 28px', padding:0, listStyle:'disc' }}>
            {a.itens.map((it, i) => (
              <li key={i} style={{ fontSize:'13px', color:'#475569', marginBottom:'4px', lineHeight:'1.5' }}>{it}</li>
            ))}
          </ul>
          <hr style={{ margin:'16px 0 0', border:'none', borderTop:'1px solid #f1f5f9' }} />
        </div>
      ))}
      <div style={{ background:'#f0f9ff', borderRadius:'8px', padding:'12px', fontSize:'13px', color:'#0369a1', marginTop:'4px' }}>
        <strong>Fluxo recomendado:</strong> Cadastre os Planos → Vincule alunos (Alunos & Planos) →
        Gere mensalidades no início do mês (⚡ Gerar lote) → Registre pagamentos conforme chegam →
        Acompanhe inadimplentes no Dashboard → Consulte Parcerias para faturar Wellhub/Total Pass.
      </div>
    </div>
  </Modal>
);

// ================================================================
// COMPONENTE PRINCIPAL
// ================================================================
export const GestaoFinanceira = ({ createApi, isMobile }) => {
  const [subAba, setSubAba] = useState('dashboard');
  const [mes, setMes] = useState(new Date().getMonth() + 1);
  const [ano, setAno] = useState(new Date().getFullYear());
  const [ajudaAberta, setAjudaAberta] = useState(false);

  const subAbas = [
    { id: 'dashboard',      icon: '📊', label: 'Dashboard' },
    { id: 'mensalidades',   icon: '💳', label: 'Receitas' },
    { id: 'despesas',       icon: '💸', label: 'Despesas' },
    { id: 'inadimplencia',  icon: '⚠️', label: 'Inadimplência' },
    { id: 'extrato',        icon: '📋', label: 'Extrato Aluno' },
    { id: 'alunos',         icon: '👤', label: 'Alunos & Planos' },
    { id: 'pacotes',        icon: '🎟️', label: 'Pacotes' },
    { id: 'parcerias',      icon: '🤝', label: 'Parcerias' },
    { id: 'produtos',       icon: '🛒', label: 'Produtos' },
    { id: 'planos',         icon: '🗂️', label: 'Planos' },
    { id: 'relatorio',      icon: '📈', label: 'Relatório' },
  ];

  return (
    <div style={S.container}>
      {ajudaAberta && <Ajuda onClose={() => setAjudaAberta(false)} />}

      {/* Sub-abas estilo pill — ícone + nome, fundo e borda ao selecionar */}
      <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'20px' }}>
        <div style={{
          display: 'flex', gap: '6px', padding: '4px', flex: 1,
          background: '#f1f5f9', borderRadius: '14px',
          overflowX: 'auto', WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none',
        }}>
          {subAbas.map(a => {
            const active = subAba === a.id;
            return (
              <button key={a.id} onClick={() => setSubAba(a.id)} style={{
                display: 'flex', alignItems: 'center', gap: '6px',
                padding: isMobile ? '8px 12px' : '9px 16px',
                borderRadius: '10px', border: active ? '1.5px solid #0f5a30' : '1.5px solid transparent',
                background: active ? '#0f5a30' : 'transparent',
                color: active ? '#fff' : '#475569',
                fontWeight: active ? 700 : 500,
                fontSize: isMobile ? '12px' : '13px',
                whiteSpace: 'nowrap', cursor: 'pointer',
                transition: 'all 0.18s ease', flexShrink: 0,
                WebkitTapHighlightColor: 'transparent',
                boxShadow: active ? '0 2px 8px rgba(99,102,241,0.3)' : 'none',
              }}>
                <span style={{ fontSize: isMobile ? '15px' : '14px' }}>{a.icon}</span>
                {a.label}
              </button>
            );
          })}
        </div>
        <button
          onClick={() => setAjudaAberta(true)}
          title="Abrir manual de ajuda"
          style={{
            flexShrink: 0, width:'36px', height:'36px', borderRadius:'50%',
            border:'1.5px solid #e2e8f0', background:'#fff', cursor:'pointer',
            fontSize:'16px', display:'flex', alignItems:'center', justifyContent:'center',
            color:'#64748b', transition:'all .15s',
          }}
        >?</button>
      </div>

      {subAba === 'dashboard'     && <Dashboard     createApi={createApi} mes={mes} ano={ano} setMes={setMes} setAno={setAno} isMobile={isMobile} />}
      {subAba === 'mensalidades'  && <Mensalidades  createApi={createApi} mes={mes} ano={ano} setMes={setMes} setAno={setAno} isMobile={isMobile} />}
      {subAba === 'inadimplencia' && <Inadimplencia createApi={createApi} isMobile={isMobile} />}
      {subAba === 'extrato'       && <ExtratoAluno  createApi={createApi} isMobile={isMobile} />}
      {subAba === 'alunos'        && <AlunosPlanos  createApi={createApi} isMobile={isMobile} />}
      {subAba === 'pacotes'       && <Pacotes       createApi={createApi} isMobile={isMobile} />}
      {subAba === 'parcerias'     && <Parcerias     createApi={createApi} isMobile={isMobile} />}
      {subAba === 'produtos'      && <Produtos      createApi={createApi} isMobile={isMobile} />}
      {subAba === 'planos'        && <Planos        createApi={createApi} />}
      {subAba === 'despesas'      && <Despesas      createApi={createApi} isMobile={isMobile} />}
      {subAba === 'relatorio'     && <Relatorio     createApi={createApi} isMobile={isMobile} />}
    </div>
  );
};
